import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    franchiseUser: null,
    franchiseUsers: null,
    franchiseUsersSearch: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const franchiseUserReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.FRANCHISEUSER_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.FRANCHISEUSER_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.FRANCHISEUSER_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default franchiseUserReducer;
